window.addEventListener("DOMContentLoaded", () => {
  const questions = document.getElementsByClassName("question-box-taxdown");

  if (questions.length > 0) {
    [...questions].forEach((question) => {
      const questionId = question.dataset.id;
      question.addEventListener("click", (e) => {
        const content = document.getElementById(`question-${questionId}`);
        const arrow = document.getElementById(`arrow-${questionId}`);
        e.currentTarget.classList.toggle('active');
        content.classList.toggle('active');
        arrow.classList.toggle('active');
      });
    });
  }

});
